export default "__VITE_ASSET__74acd74e__"